export function SkeletonCard() {
  return (
    <div className="staff-skeleton-card" aria-hidden="true">
      <div className="staff-skeleton-line staff-skeleton-line--short" />
      <div className="staff-skeleton-line" />
      <div className="staff-skeleton-line staff-skeleton-line--medium" />
    </div>
  );
}
